import { computed, makeObservable } from 'mobx';

import { PlanVersionType, TPlanVersion } from '../comparison/types';
import { DraftsStore } from '../drafts/drafts-store';

import { PlanVersionStore } from './plan-version-store';

/**
 * Заготовка под будущий сервис версий ковра, объединяющий в себе функционал текущего стора версий и стора драфтов
 */
export class PlanVersionsService {
  private readonly draftsStore: DraftsStore;
  private readonly depPlanVersionsStore: PlanVersionStore;

  constructor(draftsStore: DraftsStore, depPlanVersionsStore: PlanVersionStore) {
    this.draftsStore = draftsStore;
    this.depPlanVersionsStore = depPlanVersionsStore;

    makeObservable(this);
  }

  @computed
  get currentVersion(): TPlanVersion | null {
    return this.draftsStore.draft ?? this.depPlanVersionsStore.version ?? null;
  }

  @computed
  get publicDraft(): TPlanVersion | null {
    return this.depPlanVersionsStore.actualVersions.find((v) => v.data.versionType === PlanVersionType.public) ?? null;
  }

  isDraftOfPublicDraftVersion = (version: number | TPlanVersion): boolean => {
    const draft = typeof version === 'number' ? this.draftsStore.draftsList.find((d) => d.id === version) : version;

    if (!draft) {
      return false;
    }

    const correspondingPlanVersion = this.depPlanVersionsStore.actualVersions.find(
      (v) => v.id === draft.data.parentVersionId,
    );

    return correspondingPlanVersion?.data.versionType === PlanVersionType.public;
  };

  init = async () => {
    await Promise.all([this.draftsStore.init(), this.depPlanVersionsStore.init()]);
  };
}
